module.exports = __webpack_public_path__ + "img/f357af51c5ba52196c719b255b95ef1c.png";